import React, {Component} from 'react';
import ActiveTender from "./ActiveTender";
import BackEnd from "../../../../backend/BackEnd";
import {Link} from "react-router-dom";
import SearchForm from "../../components/SearchForm";
import PermissionsRequired from "../../../../utils/components/PermissionsRequired";
import TenderListBase from "../components/TenderListBase";
import Pager from "../../../../controls/Pager";
import {numericForms} from "../../../../utils/formatters";

class ActiveTenderList extends TenderListBase {
    static propTypes = {};
    static defaultProps = {
        pageSize: 10
    };
    state = {
        isLoading: false,
        deliveryTypes: [],
        payers: [],
        paymentConditions: [],
        tenderTypes: [],
        items: [],
        totalCount: 0,
        pageIndex: 0
    };
    searchTenders = new BackEnd.ActiveTendersOperator.SearchTenders(this);

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="px-nav-icon ion-cube"/>Тендеры /
                                </span> Активные
                            </h1>
                        </div>
                        <PermissionsRequired permissions={[1005]}>
                            <div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">
                                <Link to="/tenders/create" className="btn btn-primary btn-block">
                                    <i className="fa fa-plus"/> Создать тендер
                                </Link>
                            </div>
                        </PermissionsRequired>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-4 pull-xxl-right m-b-2">
                        <SearchForm showClientCompany={true}
                                    showAdvertsOnly={true}
                                    onChange={criteria => this.search(criteria, 0)}/>
                    </div>
                    <div className="col-xxl-8">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="col-md-6 p-t-1">
                                    {
                                        !this.state.isLoading &&
                                        `Всего найдено ${numericForms(this.state.totalCount, 'тендер', 'тендера', 'тендеров')}`
                                    }
                                </div>
                                <div className="col-md-6">
                                    <div className="pull-right">
                                        <Pager className="p-a-0 m-a-0" size="sm"
                                               pageSize={this.props.pageSize}
                                               pageIndex={this.state.pageIndex}
                                               totalCount={this.state.totalCount}
                                               onChange={pageIndex => this.updatePageIndex(pageIndex)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.isLoading
                                ? this.loadingSpinner
                                : this.state.items.map(tender =>
                                    <ActiveTender key={tender.tenderId} data={tender}
                                                  deliveryTypes={this.state.deliveryTypes}
                                                  payers={this.state.payers}
                                                  paymentConditions={this.state.paymentConditions}
                                                  tenderTypes={this.state.tenderTypes}
                                                  onUpdate={() => this.search()}/>)
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ActiveTenderList;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/Active/ActiveTenderList.js